/* @flow */

export {EditableLabel} from './editable-label';
